import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import swal from "sweetalert";
import { getDropDownVal } from "../dropdownUtils";
import NearMissAccident from "./NearMissAccident";
import CustomLoader from "../static/CustomLoader";
import {
  MasterPage,
  MasterToolbar,
  MasterButton,
  MasterSearch,
  MasterGrid,
  MasterDialog,
  MasterConfirmDialog,
} from "../static/Masterpage";

const NearMissAccidentListing = () => {
  const apiUrl = localStorage.getItem("apiUrl");
  const dbTokenData = localStorage.getItem("dbTokenData");
  const headers = {
    Authorization: `Bearer ${dbTokenData}`,
    "Content-Type": "application/json",
    dbMaster: "",
  };

  const [userData, setUserData] = useState([{}]);
  const [filterData, setFilterData] = useState([{}]);
  const [serach, setSerach] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [deptcodeList, setDeptcodeList] = useState([{}]);
  const [usedCodeList, setUsedCodeList] = useState([{}]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [showConfirm, setShowConfirm] = useState(false);
  const [density, setDensity] = useState("standard");
  const [editShow, setEditShow] = useState(false);

  const editHandleClose = () => {
    setShowConfirm(true);
  };

  const editHandleShow = () => {
    if (selectedData.length > 1 || selectedData.length === 0) {
      toast.warning("Please Select only one value");
      return;
    }
    setEditShow(true);
  };

  const handleConfirmClose = () => {
    setShowConfirm(false);
    setEditShow(false);
  };

  const handleCancelClose = () => {
    setShowConfirm(false);
  };

  const columns = [
    {
      field: "code",
      headerName: "Code",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "startdatetime",
      headerName: "Start Date",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "enddatetime",
      headerName: "End Date",
      width: 150,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "deptName",
      headerName: "Department",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "location",
      headerName: "Location",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "accidentinfo",
      headerName: "Accident Info",
      width: 400,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "userName",
      headerName: "User",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "statusName",
      headerName: "Status",
      width: 100,
      headerAlign: "center",
      align: "center",
    },
  ];

  useEffect(() => {
    fetchUSer();
  }, [refresh]);

  const fetchUSer = async () => {
    try {
      axios
        .get(apiUrl + "user", {
          headers,
        })
        .then((response) => {
          setUsedCodeList(response.data);
          const sectionOption = response.data.map((op) => ({
            value: op.empcode,
            label: op.userid,
          }));
          setUsedCodeList(sectionOption);
          fetchDepartment(sectionOption);
        })
        .catch((error) => {
          setUsedCodeList([{}]);
        });
    } catch (error) {
      setUsedCodeList([{}]);
    }
  };

  const fetchDepartment = async (UserOption) => {
    try {
      axios
        .get(apiUrl + "division", { headers })
        .then((response) => {
          setDeptcodeList(response.data);
          const sectionOption = response.data.map((op) => ({
            value: op.code,
            label: op.name,
          }));
          setDeptcodeList(sectionOption);
          fetchStatusOptions(UserOption, sectionOption);
        })
        .catch((error) => {
          setDeptcodeList([{}]);
        });
    } catch (error) {
      setDeptcodeList([{}]);
    }
  };

  const fetchStatusOptions = (UserOption, deptOption) => {
    try {
      const response = getDropDownVal("DEPS");
      const actOption = response.map((op) => ({
        value: op.code,
        label: op.value,
      }));
      setStatusOptions(actOption);
      fetchData(UserOption, deptOption, actOption);
    } catch (error) {
      console.log("error");
    }
  };

  const fetchData = async (UserOption, deptOption, actOption) => {
    try {
      axios
        .get(apiUrl + "nearMissaccident", { headers })
        .then((response) => {
          const enrichedData = response.data.map((item) => {
            const matchedStatus = actOption.find(
              (sku) => sku.value === item.status,
            );

            const matchedUser = UserOption.find(
              (sku) => sku.value === item.user,
            );

            const matchedFactory = deptOption.find(
              (sku) => sku.value === item.divcode,
            );

            return {
              ...item,
              statusName: matchedStatus ? matchedStatus.label : item.status,
              userName: matchedUser ? matchedUser.label : item.user,
              deptName: matchedFactory ? matchedFactory.label : item.divcode,
            };
          });

          setUserData(enrichedData);
          setFilterData(enrichedData);
          setRefresh(false);
          setSelectedData([]);
        })
        .catch((error) => {
          console.log("error " + error);
          setUserData([{}]);
        });
    } catch (error) {
      setUserData([{}]);
    }
  };

  const handlesearch = (event) => {
    const getSearchdata = event.target.value;
    const getSearch = event.target.value.toLowerCase();

    if (getSearch.length > 0) {
      const searchdata = filterData.filter((item) =>
        Object.keys(item).some((key) =>
          String(item[key]).toLowerCase().includes(getSearch),
        ),
      );
      setUserData(searchdata);
    } else {
      setUserData(filterData);
    }

    setSerach(getSearchdata);
  };

  return (
    <>
      <MasterPage>
        <MasterToolbar
          actions={
            <MasterButton
              variant="update"
              tooltip="View or update selected Safety Log"
              onClick={editHandleShow}
            >
              View Details
            </MasterButton>
          }
          search={
            <MasterSearch
              tooltip="Search by All"
              value={serach}
              onChange={handlesearch}
              inputRef={(input) => input && input.focus()}
            />
          }
        />

        <MasterGrid
          density={density}
          onDensityChange={(newDensityString) => setDensity(newDensityString)}
          rows={
            userData !== null &&
            userData.length > 0 &&
            Object.keys(userData[0]).length !== 0 &&
            userData
          }
          columns={columns}
          onSelectionModelChange={(ids) => setSelectedData(ids)}
        />
      </MasterPage>

      <MasterDialog
        open={editShow}
        onHide={editHandleClose}
        title="Edit Safety Log"
        maxWidth="lg"
      >
        <NearMissAccident
          selectedId={selectedData && selectedData[0]}
          mode="U"
          onHide={editHandleClose}
          setRefresh={setRefresh}
          deptcodeList={deptcodeList}
          usedCodeList={usedCodeList}
          statusOptions={statusOptions}
        />
      </MasterDialog>

      <MasterConfirmDialog
        show={showConfirm}
        title="Close Confirmation"
        message="Are you sure you want to close this modal?"
        onConfirm={handleConfirmClose}
        onCancel={handleCancelClose}
      />

      {userData.length === 0 && <CustomLoader />}
    </>
  );
};

export default NearMissAccidentListing;
